export const bookingImageGalleryStyles = {
  container: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  gradientBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(270deg, #F6F6F6 0%, rgba(246, 246, 246, 0) 36.87%, rgba(246, 246, 246, 0) 62.59%, rgba(246, 246, 246, 0.9) 100%)',
    zIndex: 10,
    pointerEvents: 'none',
  
  },
  imageContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: {xs: '30px', lg: '50px'},
    zIndex: 2,
    minHeight: {xs: '400px', lg: '600px'},
  },
  cardWrapper: {
    flexShrink: 0,
    position: 'relative',
  },
  card1: {
    marginTop: "10%",
    filter: 'blur(8px)',
    zoom: 0.9,
    backdropFilter: 'blur(8px)',
  },
  card2: {
    marginTop: "3%",
    filter: 'blur(4px)',
    zoom: 0.95,
    backdropFilter: 'blur(4px)',
  },
  card3: {
    // No additional styles - center card
  },
  card4: {
    marginTop: "3%",
    filter: 'blur(4px)',
    zoom: 0.95,
    backdropFilter: 'blur(4px)',
  },
  card5: {
    marginTop: "10%",
    filter: 'blur(8px)',
    zoom: 0.9,
    backdropFilter: 'blur(8px)',
  },
  slideUpFromBottom: (isAnimating, delay, rotation, cardIndex) => {
    // Calculate offset from center for each card
    // Card indices: 0 (leftmost), 1, 2 (center), 3, 4 (rightmost)
    const offsets = [-920, -460, 0, 460, 920]; // pixels from center
    const offset = offsets[cardIndex] || 0;
    
    return {
      opacity: isAnimating ? 1 : 0,
      transformOrigin: 'center center',
      transform: isAnimating
        ? `translateX(0) translateY(0) rotate(${rotation}) scale(1)`
        : `translateX(${offset}px) translateY(0) rotate(${rotation}) scale(0.6)`,
      transition: `opacity 0.8s ease-out ${delay}s, transform 0.8s ease-out ${delay}s`,
    };
  },
};
